(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

window.addEventListener('DOMContentLoaded', function () {
  var mailTab = document.querySelector('.article-tab#mail');
  var enterpriseId = window.enterpriseId;
  var orientationId = window.orientationId;
  var mailForm = mailTab.querySelector('form'),
      contactType = mailForm.querySelector('#ContactMailSfType_requestType'),
      contactEmailService = mailForm.querySelector('#ContactMailSfType_service'),
      contactEmailFamilyProgram = mailForm.querySelector('#ContactMailSfType_IdFamilyProgram'),
      contactEmailTypeProgram = mailForm.querySelector('#ContactMailSfType_IdProgram'),
      contactEmailTypeCampus = mailForm.querySelector('#ContactMailSfType_IdCampus'),
      contactEmailCivility = mailForm.querySelector('#ContactMailSfType_civility'),
      contactEmailLeadProductB2B = mailForm.querySelector('#ContactMailSfType_leadProductB2B'),
      contactEmailOriginDetails = mailForm.querySelector('#ContactMailSfType_originDetails'),
      formContactInputs = mailForm.querySelectorAll('#FormContainerTypeMail .form-group'),
      selectElements = mailForm.querySelectorAll('select');
  formContactInputs.forEach(function (element) {
    element.style.display = 'none';
    var options = element.querySelectorAll('select option');
    options.forEach(function (option) {
      if (option.getAttribute('selected')) {
        option.closest('.form-group').style.display = 'block';
      }
    });
  });
  contactType.closest('.form-group').style.display = 'block';

  if (mailForm.dataset.postSubmitted || contactType.selectedIndex > 0) {
    switch (contactType.options[contactType.selectedIndex].dataset.id) {
      case orientationId:
        contactEmailService.closest('.form-group').style.display = 'none';
        contactEmailFamilyProgram.setAttribute('required', '');
        contactEmailFamilyProgram.closest('.form-group').style.display = 'block';
        contactEmailTypeProgram.setAttribute('required', '');
        contactEmailTypeProgram.closest('.form-group').style.display = 'block';
        contactEmailCivility.closest('.form-group').style.display = 'none';
        contactEmailLeadProductB2B.closest('.form-group').style.display = 'none';
        contactEmailOriginDetails.closest('.form-group').style.display = 'none';

        if (typeof contactEmailTypeCampus !== 'undefined') {
          var chosenProgramId = contactEmailTypeProgram.value;
          var campusSelectOptions = contactEmailTypeCampus.querySelectorAll('option');
          campusSelectOptions.forEach(function (campusChoice) {
            try {
              var datasetArray = JSON.parse(campusChoice.dataset.parentPrograms);

              if (datasetArray.includes(chosenProgramId)) {
                campusChoice.style.display = 'block';
                campusChoice.removeAttribute('disabled');
              } else {
                campusChoice.style.display = 'none';
                campusChoice.setAttribute('disabled', '');
              }
            } catch (e) {// Do nothing
            }
          });
        }

        break;

      case enterpriseId:
        contactEmailFamilyProgram.closest('.form-group').style.display = 'none';
        contactEmailTypeProgram.closest('.form-group').style.display = 'none';
        contactEmailService.setAttribute('required', '');
        contactEmailService.closest('.form-group').style.display = 'block';
        contactEmailCivility.closest('.form-group').style.display = 'block';
        contactEmailLeadProductB2B.setAttribute('required');
        contactEmailLeadProductB2B.closest('.form-group').style.display = 'block';
        contactEmailLeadProductB2B.closest('.form-group').querySelector('label').classList.add('required');
        contactEmailOriginDetails.setAttribute('required');
        contactEmailOriginDetails.closest('.form-group').style.display = 'block';
        contactEmailOriginDetails.closest('.form-group').querySelector('label').classList.add('required');
        break;

      default: // Do nothing

    }
  }

  selectElements.forEach(function (element) {
    if (/requestType|IdFamilyProgram|IdProgram|service|IdCampus$/.test(element.id)) {
      $(element).select2();
    }
  });
  $(contactType).on('change', function (evt) {
    var selectedType = evt.target.options[evt.target.selectedIndex].dataset.id;

    if (selectedType === enterpriseId) {
      contactEmailService.setAttribute('required', '');
      contactEmailService.closest('.form-group').style.display = 'block';
      contactEmailService.closest('.form-group').querySelector('label').classList.add('required');
      contactEmailFamilyProgram.removeAttribute('required');
      contactEmailFamilyProgram.closest('.form-group').style.display = 'none'; //contactEmailFamilyProgram.options[evt.target.selectedIndex].selected = false;

      contactEmailTypeProgram.removeAttribute('required');
      contactEmailTypeProgram.closest('.form-group').style.display = 'none'; //contactEmailTypeProgram.options[evt.target.selectedIndex].selected = false;

      contactEmailCivility.closest('.form-group').style.display = 'block';
      contactEmailLeadProductB2B.setAttribute('required', '');
      contactEmailLeadProductB2B.closest('.form-group').style.display = 'block';
      contactEmailLeadProductB2B.closest('.form-group').querySelector('label').classList.add('required');
      contactEmailOriginDetails.setAttribute('required', '');
      contactEmailOriginDetails.closest('.form-group').style.display = 'block';
      contactEmailOriginDetails.closest('.form-group').querySelector('label').classList.add('required');
    } else if (selectedType === orientationId) {
      contactEmailFamilyProgram.setAttribute('required', '');
      contactEmailFamilyProgram.closest('.form-group').style.display = 'block';
      contactEmailFamilyProgram.closest('.form-group').querySelector('label').classList.add('required');
      contactEmailTypeProgram.setAttribute('required', '');
      contactEmailTypeProgram.closest('.form-group').style.display = 'block';
      contactEmailTypeProgram.closest('.form-group').querySelector('label').classList.add('required');
      contactEmailService.removeAttribute('required');
      contactEmailService.closest('.form-group').style.display = 'none'; //contactEmailService.options[evt.target.selectedIndex].selected = false;

      contactEmailCivility.closest('.form-group').style.display = 'none';
      contactEmailLeadProductB2B.removeAttribute('required');
      contactEmailLeadProductB2B.closest('.form-group').style.display = 'none';
      contactEmailLeadProductB2B.closest('.form-group').querySelector('label').classList.remove('required');
      contactEmailOriginDetails.removeAttribute('required');
      contactEmailOriginDetails.closest('.form-group').style.display = 'none';
      contactEmailOriginDetails.closest('.form-group').querySelector('label').classList.remove('required');
    } else if (!selectedType) {
      formContactInputs.forEach(function (element) {
        element.style.display = 'none';
        element.querySelector('select').classList.remove('required');
        element.querySelector('label').classList.remove('required');
      });
      contactType.classList.add('required');
      contactType.closest('.form-group').style.display = 'block';
      contactType.closest('.form-group').querySelector('label').classList.add('required');
    }
  }); // Program family inputs event listener

  $(contactEmailFamilyProgram).on('change', function (evt) {
    var programSelectOptions = contactEmailTypeProgram.querySelectorAll('option');
    var chosenEmailFamilyProgram = evt.target.value; // Hide programs which are not children of the program family

    programSelectOptions.forEach(function (programChoice) {
      if (programChoice.dataset.parentFamily === chosenEmailFamilyProgram) {
        programChoice.style.display = 'block';
        programChoice.removeAttribute('disabled');
      } else {
        programChoice.style.display = 'none';
        programChoice.setAttribute('disabled', '');
      }
    });
    $(contactEmailTypeProgram).select2('destroy');
    $(contactEmailTypeProgram).select2();
    $(contactEmailTypeProgram).val('').trigger('change');
  });
  $(contactEmailTypeProgram).on('change', function (evt) {
    var chosenProgramId = evt.target.value;

    if (typeof contactEmailTypeCampus !== 'undefined') {
      var _campusSelectOptions = contactEmailTypeCampus.querySelectorAll('option');

      _campusSelectOptions.forEach(function (campusChoice) {
        try {
          var datasetArray = JSON.parse(campusChoice.dataset.parentPrograms);

          if (datasetArray.includes(chosenProgramId)) {
            campusChoice.style.display = 'block';
            campusChoice.removeAttribute('disabled');
          } else {
            campusChoice.style.display = 'none';
            campusChoice.setAttribute('disabled', '');
          }
        } catch (e) {// Do nothing
        }
      });

      $(contactEmailTypeCampus).select2('destroy');
      $(contactEmailTypeCampus).select2();
      $(contactEmailTypeCampus).val('').trigger('change');
    }
  });
  $('[id$="_requestType"], [id$="_IdFamilyProgram"], [id$="_IdProgram"], [id$="_IdCampus"], [id$="_service"]').on('select2:close', function () {
    this.dispatchEvent(new Event('blur'));
  }).each(function () {
    $(this).closest('.element').find('.select2-selection').toggleClass('completed', $(this).val().length > 0);
  });
});

},{}]},{},[1]);
